import { EventBus } from './EventBus';
import { GameState } from '../systems/GameState';
import { SaveSystem } from '../systems/SaveSystem';

/**
 * 全局总控（单例）
 * 负责游戏的整体生命周期：启动、存档管理、场景调度
 */
export class GameManager {
    private static instance: GameManager;
    private initialized = false;

    private constructor() {}

    static getInstance(): GameManager {
        if (!this.instance) {
            this.instance = new GameManager();
        }
        return this.instance;
    }

    /** 启动游戏（入口调用） */
    init(): void {
        if (this.initialized) return;
        this.initialized = true;

        // 加载元数据（跨周目继承数据）
        SaveSystem.getInstance().loadMeta();

        console.log('[GameManager] Game initialized.');
    }

    /** 开始新游戏 */
    newGame(): GameState {
        const state = GameState.getInstance();
        state.createNewGame();
        // 开场那届金枢奖（第 23 届，主线注脚）⛔ 在这里落地：批 G 起所有颁奖夜（含剧情届）
        // 都由玩家第一次点「确认行程并进入下月」时结算并播出（GameLoop.confirmMonth）
        return state;
    }

    /** 继续游戏（读档） */
    continueGame(): GameState | null {
        const data = SaveSystem.getInstance().load();
        if (!data) return null;
        const state = GameState.getInstance();
        state.load(data);
        return state;
    }

    /** 保存当前进度 */
    saveGame(): void {
        SaveSystem.getInstance().save();
    }

    /** 游戏结束，进入周目结算 */
    gameOver(reason: string): void {
        EventBus.emit('gameOver', reason);
        console.log(`[GameManager] Game over: ${reason}`);
    }

    /** 重置（清理状态） */
    reset(): void {
        GameState.reset();
    }
}

/** 便捷导出的全局单例 */
export const gameManager = GameManager.getInstance();